import {
  OnboardingTarget,
  onboardingTarget,
} from "../onboarding/onboardingTargets";
import AddIcon from "@mui/icons-material/Add";
import MovieCreationOutlinedIcon from "@mui/icons-material/MovieCreationOutlined";
import { useAddTake3D } from "../timeline_3d/useAddTake3D";

export default function TrainingEditor3DEmpty() {
  const { addTake } = useAddTake3D();

  return (
    <div
      className="flex-1 flex flex-col items-center justify-center gap-4 text-creator-text-sub"
      data-testid="trainingeditor-3d-empty"
      {...onboardingTarget(OnboardingTarget.Editor3DEmptyHero)}
    >
      <MovieCreationOutlinedIcon sx={{ fontSize: 64 }} />
      <span className="text-[18px] font-semibold">No takes yet</span>
      <button
        type="button"
        className="h-[38px] inline-flex items-center justify-center gap-1.5 rounded-full px-4 bg-creator-primary hover:bg-creator-primary-hover text-white text-[14px] font-semibold cursor-pointer"
        onClick={addTake}
      >
        <AddIcon fontSize="inherit" />
        Add take
      </button>
    </div>
  );
}
